var _circle, _path, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "-3 -3 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#18C67F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5002 12.5013V16.608L28.1668 12.9596V23.043L24.5002 19.3946V23.5013C24.5002 24.5096 23.6752 25.3346 22.6668 25.3346H11.6668C10.6585 25.3346 9.8335 24.5096 9.8335 23.5013V12.5013C9.8335 11.493 10.6585 10.668 11.6668 10.668H22.6668C23.6752 10.668 24.5002 11.493 24.5002 12.5013ZM22.6668 12.5013H11.6668V23.5013H22.6668V12.5013Z",
    fill: "#00331E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0738,
    cy: 24.8766,
    r: 4.4,
    fill: "#18C67F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0695 20.293C14.5395 20.293 12.4907 22.3463 12.4907 24.8763C12.4907 27.4063 14.5395 29.4596 17.0695 29.4596C19.6041 29.4596 21.6574 27.4063 21.6574 24.8763C21.6574 22.3463 19.6041 20.293 17.0695 20.293ZM17.0741 28.543C15.0482 28.543 13.4074 26.9021 13.4074 24.8763C13.4074 22.8505 15.0482 21.2096 17.0741 21.2096C19.0999 21.2096 20.7407 22.8505 20.7407 24.8763C20.7407 26.9021 19.0999 28.543 17.0741 28.543ZM16.6157 25.3667L19.132 26.8746L19.5995 26.0863L17.5324 24.8442V22.3188H16.6157V25.3667Z",
    fill: "#00331E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoIcon);
export default __webpack_public_path__ + "static/media/expo_icon.ac4fa8c24880aaa1ca36ef97cbd4b818.svg";
export { ForwardRef as ReactComponent };